export default __webpack_public_path__ + "static/media/avatar-2.354429fd.png";